<template>
  <div class="input-with-unit" :style="{ width: props.width }">
    <div class="input-with-unit__wrapper">
      <div class="input-with-unit__input-wrapper">
        <el-input
          v-model="inputValue"
          @focus="showSuggestions = true"
          @blur="handleBlur"
          @input="handleInput"
          type="text"
          class="input-with-unit__input"
          :placeholder="props.placeholder"
        />
        <ul
          v-if="showSuggestions && props.suggestions.length"
          class="input-with-unit__suggestion-dropdown"
        >
          <li
            v-for="(suggestion, index) in props.suggestions"
            :key="index"
            @mousedown.prevent="selectSuggestion(suggestion)"
            class="input-with-unit__suggestion-item"
          >
            {{ suggestion }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from "vue";
const emit = defineEmits(["update:model-value"]);
const props = defineProps({
  suggestions: {
    type: Array,
    default: () => [],
  },
  width: {
    type: String,
    default: "100%",
  },
  placeholder: {
    type: String,
    default: "",
  },
  unit: {
    type: String,
    default: undefined,
  },
  value: {
    type: [String, Number],
    default: "",
  },
});

const inputValue = ref(props.value);
const showSuggestions = ref(false);
const selectSuggestion = (value) => {
  inputValue.value = value;
  showSuggestions.value = false;
  emit("update:model-value", inputValue.value);
};
const hideSuggestions = () => {
  setTimeout(() => {
    showSuggestions.value = false;
  }, 100);
};

const handleBlur = () => {
  hideSuggestions();
  const raw = String(inputValue.value).trim();
  if (!raw) return;

  let value = parseFloat(raw);
  if (isNaN(value) || value < 0) value = 0;

  if (props.unit === "%" && value > 100) {
    value = 100;
  }

  inputValue.value = value.toString();
  emit("update:model-value", inputValue.value);
};

const handleInput = () => {
  emit("update:model-value", inputValue.value);
  setTimeout(() => {
    showSuggestions.value = false;
  }, 200);
};

watch(
  () => props.value,
  (newVal) => {
    inputValue.value = newVal;
  }
);
</script>

<style scoped lang="scss">
.input-with-unit {
  width: 100%;
}

.input-with-unit__wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.input-with-unit__input-wrapper {
  position: relative;
  width: 100%;
}

.input-with-unit__input {
  width: 100%;
  border-radius: 4px;
}

.input-with-unit__select {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 60px;
}

.input-with-unit__suggestion-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  margin-top: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-height: 150px;
  overflow-y: auto;
  border-radius: 4px;
}

.input-with-unit__suggestion-item {
  padding: 6px 8px;
  cursor: pointer;
}

.input-with-unit__suggestion-item:hover {
  background-color: #f5f5f5;
}
</style>
